import { Link } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/components/TextField';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { IPersonaSharedProps, Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import Label from 'reactstrap/lib/Label';
import { IEmailArchive } from '../../../models/IEmailArchive';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import DateUtils from '../../../utils/DateUtils';
import { IWelcomeEmailProps } from './IWelcomeEmailProps';
import { IWelcomeEmailState } from './IWelcomeEmailState';

const getStyles = () => {
    return {
        root: {
            maxWidth: "100%",
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "13px", color: '#005269'
});

const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269",
    backgroundColor: '#35AFD1', color: "#ffffff"
});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px"
});
const responsiveTableBodyCellText = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "left",
    fontWeight: "bold"
});
const responsiveTableBodyCellSpan = mergeStyles({
    width: "75%", textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", display: "block", whiteSpace: "nowrap"
});
const responsiveTableBodyCellNavigation = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right",
    fontWeight: "bold"
});
const submitButton = mergeStyles({ backgroundColor: '#73797D', marginRight: "5px" });
const innerPanel = mergeStyles({ margin: "0 auto", width: "auto", maxWidth: "100%", color: '#005269', paddingBottom: "20px" });
const userMessage = mergeStyles({ fontSize: "13px", fontWeight: "bold", paddingBottom: "5px" });
const mailMessage = mergeStyles({ textAlign: "justify", padding: "5px" });
const alertMessage = mergeStyles({ color: "#E9512D", fontSize: "13px" });
const textBoxPanel = mergeStyles({ display: "inline-block", verticalAlign: "bottom", marginRight: "5px", minWidth: "40%" });
export interface IDetailsList {
    key: string;
    fromEmailAddress: string;
    toEmailAddress: string;
    subject: string;
    message: string;
    sentDate: Date;
    category: string;
}
export default class WelcomeEmail extends React.Component<IWelcomeEmailProps, IWelcomeEmailState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private EmailError: string;
    constructor(props: IWelcomeEmailProps, state: IWelcomeEmailState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.EmailError = '';
        this.state = {
            loading: false,
            isValidData: true,
            hideDialog: true,
            emailId: "",
            items: [],
            isOpen: false,
            fromEmailAddress: "",
            toEmailAddress: "",
            subject: "",
            message: "",
            sentDate: new Date(Date.now()),

            totalRecords: 0,
            startIndex: 0,
            recordsToShow: 10,
            endIndex: 10
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.getRecentInvitations = this.getRecentInvitations.bind(this);
    }

    public async componentDidMount() {
        this.getRecentInvitations();
    }
    public getRecentInvitations = async (): Promise<void> => {
        try {
            let emailArchive: IEmailArchive[] = await this.connectionContext.get(`EmailArchive/${"invite"}`);
            this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
                prevState.items = [];
                emailArchive.forEach((item: IEmailArchive) => {
                    prevState.items.push({
                        key: item.id || "", fromEmailAddress: item.fromEmailAddress, toEmailAddress: item.toEmailAddress,
                        subject: item.subject, message: item.message, category: item.category, sentDate: item.sentDate
                    });
                })
                prevState.endIndex = (prevState.items.length > prevState.recordsToShow ? prevState.recordsToShow : prevState.items.length);
                return prevState;
            });

        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    public openPanel = (item: IDetailsList): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.fromEmailAddress = item.fromEmailAddress;
            prevState.toEmailAddress = item.toEmailAddress;
            prevState.subject = item.subject;
            prevState.message = item.message;
            prevState.isOpen = true;
            return prevState;
        });
    }
    public dismissPanel = (): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.isOpen = false;
            return prevState;
        });
    }
    public firstSet = (): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.startIndex = 0;
            prevState.endIndex = (prevState.recordsToShow > prevState.items.length ? prevState.items.length : prevState.recordsToShow);
            return prevState;
        });
    }
    public lastSet = (): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            if (prevState.recordsToShow > prevState.items.length) {
                prevState.startIndex = 0;
                prevState.endIndex = prevState.items.length;
            }
            else {
                let balanceRecord: number = 0;
                balanceRecord = Math.ceil(prevState.items.length % prevState.recordsToShow);
                if (balanceRecord > 0) {
                    prevState.startIndex = prevState.items.length - balanceRecord;
                    prevState.endIndex = prevState.items.length;
                }
                else {
                    prevState.startIndex = prevState.items.length - prevState.recordsToShow;
                    prevState.endIndex = prevState.items.length;
                }
            }
            return prevState;
        });
    }
    public previousSet = (): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.startIndex = (prevState.startIndex - prevState.recordsToShow <= 0 ? 0 : prevState.startIndex - prevState.recordsToShow);
            prevState.endIndex = (prevState.recordsToShow + prevState.startIndex > prevState.items.length ? prevState.items.length : prevState.recordsToShow + prevState.startIndex);
            return prevState;
        });
    }
    public nextSet = (): void => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.startIndex = prevState.endIndex;
            prevState.endIndex = (prevState.endIndex + prevState.recordsToShow > prevState.items.length ? prevState.items.length : prevState.endIndex + prevState.recordsToShow);
            return prevState;
        });
    }
    public render(): React.ReactElement<IWelcomeEmailProps> {
        const examplePersona: IPersonaSharedProps = {
            secondaryText: DateUtils.getFormatedDateWithTime(this.state.sentDate),
            tertiaryText: '',
            optionalText: ''
        };
        return (
            <div className={panel} >
                {
                    <Panel
                        isOpen={this.state.isOpen}
                        onDismiss={this.dismissPanel}
                        type={PanelType.large}
                        closeButtonAriaLabel="Close"
                        headerText={this.state.subject}
                    >
                        <div>{"Sender: " + this.state.fromEmailAddress}</div>
                        <Persona {...examplePersona} text={this.state.toEmailAddress} size={PersonaSize.size48} initialsColor="#005269" />
                        <Separator></Separator>
                        <div className={mailMessage} dangerouslySetInnerHTML={{ __html: (this.state.message) }}></div>
                    </Panel>
                }
                {
                    <div className={userMessage}>
                        Enter the email address of the agent to send an invitation to join Zacco's agent network.
                    </div>
                }
                {
                    <div className={innerPanel}>
                        <div className={textBoxPanel}>
                            <TextField label="Email address" required placeholder="Email address" styles={getStyles}
                                maxLength={320} value={this.state.emailId} onChange={this.getEmailValidationErrorText} errorMessage={this.EmailError} iconProps={{ iconName: 'PublicEmail' }} />
                        </div>
                        <div className={textBoxPanel}>
                            <span className={alertMessage}> * </span> Mandatory<br />
                            <PrimaryButton text="Send welcome email" data-automation-id="test" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: 'Send' }} />
                        </div>
                    </div>
                }
                {
                    <div className={userMessage}>
                        10 Recent invitations:
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTable}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableRow}>
                                    <div className={userMessage}>* Click on 'Expand' to view the mail content.</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.firstSet}>|&laquo; First</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.previousSet}>&laquo; Previous</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.nextSet}>Next &raquo;</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.lastSet}>Last &raquo;|</Link>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTableContent}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableHeaderRow}>
                                    <div className={responsiveTableBodyCellText}><strong>Sender</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Recipient</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Subject</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong>Sent on</strong></div>
                                    <div className={responsiveTableBodyCellText}><strong></strong></div>
                                </div>
                                {
                                    this.state.items.slice(this.state.startIndex, this.state.endIndex).map((item, i) => {
                                        return (
                                            <div className={responsiveTableRow}>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{item.fromEmailAddress}</span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}><a href="mailto:{item.toEmailAddress}" target="_blank" rel="noopener noreferrer"> {item.toEmailAddress}</a></span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{item.subject}</span></div>
                                                <div className={responsiveTableBodyCell}><span className={responsiveTableBodyCellSpan}>{DateUtils.getFormatedDateWithTime(item.sentDate)}</span></div>
                                                <div className={responsiveTableBodyCell}><Link onClick={() => this.openPanel(item)}>Expand</Link></div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className={responsiveMain}>
                        <div className={responsiveTable}>
                            <div className={responsiveTableBody}>
                                <div className={responsiveTableRow}>
                                    <div className={userMessage}>* Click on 'Expand' to view the mail content.</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.firstSet}>|&laquo; First</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.startIndex === 0 ? "" : <Link onClick={this.previousSet}>&laquo; Previous</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.nextSet}>Next &raquo;</Link>}</div>
                                    <div className={responsiveTableBodyCellNavigation}>{this.state.endIndex >= this.state.items.length ? "" : <Link onClick={this.lastSet}>Last &raquo;|</Link>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUp} data-automation-id="test" text="Close" className={submitButton} iconProps={{ iconName: "ChromeClose" }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
            </div>
        )
    }

    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            try {
                await this.props.connectionContext.post(`WelcomeEmail/${this.state.emailId}`, {});
                this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
                    this.handleError("Email sent", "A welcome email has been sent to the email address that you have entered.");
                    prevState.isValidData = true;
                    prevState.emailId = "";
                    return prevState;
                }, () => this.getRecentInvitations());

            } catch (exception) {
                if (exception === 409) {
                    this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
                        prevState.isValidData = false;
                        prevState.emailId = "";
                        this.handleError("Warning", "Invitation has already been sent to this email address");
                        return prevState;
                    });
                } else {
                    this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
                        prevState.isValidData = false;
                        this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                        return prevState;
                    });
                }
            }
        }
    }
    private getEmailValidationErrorText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            let newEmailToResetPasswordFor: string = value || '';

            const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
            if (newEmailToResetPasswordFor.length < 1) {
                this.EmailError = 'Email address is Required.';
                prevState.emailId = undefined;
            }
            else if (!re.test(newEmailToResetPasswordFor)) {
                this.EmailError = 'Enter a valid Email address';
                prevState.emailId = newEmailToResetPasswordFor;
            }
            else {
                this.EmailError = '';
                prevState.emailId = newEmailToResetPasswordFor;
            }
            return prevState;
        });
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;

        if (this.state.emailId === undefined) {
            this.EmailError = 'Email address is required';
            validState = false;
        } else {
            let EmailEntered: boolean = this.state.emailId.trim().length > 0;

            if (!EmailEntered) {
                this.EmailError = 'Email address is required';
                validState = false;
            }
        }

        this.setState((prevState: IWelcomeEmailState): IWelcomeEmailState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IWelcomeEmailState, props: IWelcomeEmailProps): IWelcomeEmailState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private closeModelPopUp = (): void => {
        this.setState((previousState: IWelcomeEmailState): IWelcomeEmailState => {
            previousState.hideDialog = true;
            previousState.emailId = "";
            return previousState;
        });
    }
}
